module.exports = __webpack_public_path__ + "img/Asset 4.682d3bdb.png";